import { cva, type VariantProps } from 'class-variance-authority';

export const tooltipVariants = cva(
  'bg-[#1c1c1c] text-white z-[9999] w-fit max-w-[260px] rounded-[8px] px-3 py-2 text-xs leading-[1.45] text-left text-balance shadow-[0_8px_24px_rgba(0,0,0,0.25)] transition-opacity duration-[120ms]',
  {
    variants: {
      /** AB#73557-tooltip — the 260px cap is now the DS default on the base class; this variant
       *  is kept so existing consumers passing it keep compiling. */
      constrainWidth: {
        true: 'max-w-[260px]',
      },
    },
  },
);
export type ZardTooltipVariants = VariantProps<typeof tooltipVariants>;

export const tooltipPositionVariants = cva('absolute', {
  variants: {
    position: {
      top: 'bottom-0 translate-y-full left-[calc(50%-5px)]',
      bottom: '-top-2.5 translate-y-0 rotate-180 left-[calc(50%-5px)]',
      left: 'top-[calc(50%-5px)] rotate-270 translate-y-0 -right-2.5',
      right: 'top-[calc(50%-5px)] translate-y-0 rotate-90 -left-2.5',
    },
  },
});

export type ZardTooltipPositionVariants = NonNullable<VariantProps<typeof tooltipPositionVariants>['position']>;
